import { chakra } from '@chakra-ui/react'

export const EmailOtpSvgr = chakra(
  (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
    return (
      <svg
        width={200}
        height={174}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M100.307 1 1 58.332V173h198.608V58.332L100.307 1Z"
          fill="#F5F6F8"
        />
        <path
          d="M1 58.332v11.547l99.307 57.337 99.301-57.337V58.332L100.307 1 1 58.332Z"
          fill="#F0F0F1"
        />
        <path
          d="M36.048 77.377 2.042 57.74l-1.032.592v11.527l99.306 57.337 99.302-57.337V58.332l-1.027-.592-34.016 19.637c-39.765 22.963-88.762 22.963-128.527 0Z"
          fill="#C9CCCF"
        />
        <path
          d="m1 69.879 99.307 57.337 99.301-57.337M35.527 164.615l164.081-94.736"
          stroke="#000"
          strokeWidth={0.75}
        />
        <path
          d="M31.503 173h168.105V58.332L100.307 1 1 58.332V173"
          stroke="#000"
          strokeWidth={0.75}
        />
        <path
          d="m124.83 113.066 28.64-16.622v-52.42h-28.64v69.042Z"
          fill="#000"
        />
        <path
          d="M55.924 102.07v.217l.188.108 43.982 25.315.187.108.187-.108 43.983-25.315.188-.108V33.42H55.924v68.65Z"
          fill="#4A61C0"
          stroke="#000"
          strokeWidth={0.75}
        />
        <path
          d="M67.981 82.125h1.875l-.164-3.663 3.074 1.988.942-1.65-3.265-1.675 3.265-1.675-.942-1.65-3.075 1.988.165-3.663H67.98l.164 3.663L65.07 73.8l-.941 1.65 3.265 1.675-3.265 1.675.941 1.65 3.075-1.988-.164 3.663ZM80.665 82.125h1.875l-.164-3.663 3.075 1.988.941-1.65-3.265-1.675 3.265-1.675-.941-1.65-3.075 1.988.164-3.663h-1.875l.165 3.663-3.075-1.988-.942 1.65 3.265 1.675-3.265 1.675.942 1.65 3.075-1.988-.165 3.663ZM93.35 82.125h1.874l-.164-3.663 3.075 1.988.941-1.65-3.265-1.675 3.265-1.675-.941-1.65-3.075 1.988.164-3.663H93.35l.164 3.663-3.075-1.988-.942 1.65 3.265 1.675-3.265 1.675.942 1.65 3.075-1.988-.164 3.663ZM106.034 82.125h1.874l-.164-3.663 3.075 1.988.942-1.65-3.265-1.675 3.265-1.675-.942-1.65-3.075 1.988.164-3.663h-1.874l.164 3.663-3.075-1.988-.942 1.65 3.265 1.675-3.265 1.675.942 1.65 3.075-1.988-.164 3.663ZM118.718 82.125h1.874l-.164-3.663 3.075 1.988.942-1.65-3.265-1.675 3.265-1.675-.942-1.65-3.075 1.988.164-3.663h-1.874l.164 3.663-3.075-1.988-.941 1.65 3.265 1.675-3.265 1.675.941 1.65 3.075-1.988-.164 3.663ZM131.402 82.125h1.875l-.165-3.663 3.075 1.988.942-1.65-3.265-1.675 3.265-1.675-.942-1.65-3.075 1.988.165-3.663h-1.875l.164 3.663-3.075-1.988-.941 1.65 3.265 1.675-3.265 1.675.941 1.65 3.075-1.988-.164 3.663Z"
          fill="#8998D6"
        />
      </svg>
    )
  },
)
